import React, { useCallback, useState, useMemo } from "react";
import axios from "axios";
import { useDelete } from "../customHooks/useDelete/useDelete";
import useEdit from "../customHooks/useEdit/useEdit";
import ConfirmationPrompt from "../components/ConfirmationPrompt";
import { toast } from "react-toastify";
import { ActionCells } from "../components/ActionCells";
import PermissionPrompt from "../components/PermissionPrompt";
import { usePermissions } from "../utils/Customhooks/permissionHook/usePermissionHook";
import { addProduct, deleteProduct } from "../generatedRequest/product";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { setRerender } from "../generatedSlice/productSlice";
import { updateStatus } from "../generatedRequest/product";
import { useStatus } from "../customHooks/useStatus/useStatus";
import CarouselDemo from "../app/pages/Carousel";
import useClone from "../customHooks/useClone/useClone";
import ClonePrompt from "../components/ClonePrompt";
import CloneRegionModel from "../components/CloneRegionModel";
import { addMaster } from "../generatedRequest/master";
// import  useMaster from "../customHooks/useMaster/useMaster";
import MasterFormModal from "../generatedFormModal/MasterFormModal";


const moduleName = "Product";

const ProductTableAction = ({ product, regions }: any) => {
  const { rerender1 } = useSelector((state: RootState) => state.product);
  const [showPreviewPrompt, setPreviewPrompt] = useState(false);
  const { doEdit } = useEdit(moduleName);
  // const { addMasterModel} = useMaster(moduleName)
  const dispatch = useDispatch();
  const [showPermissionPrompt, setShowPermissionPrompt] =
    useState<boolean>(false);
  const [newPayloads, setNewPayloads] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [showCloneStatusModel, setShowCloneStatusModel] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [addMasterModel, setAddMasterModel] = useState(false);

  // Get user permissions from localStorage
  const getUserPermissions = useMemo(() => {
    try {
      const userDataString = localStorage.getItem('kt-auth-react-v');
      // console.log(userDataString , "userDataString")
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        const productPermissions = userData?.data?.permissions?.find(
          (permission: any) => permission.moduleName === "Product"
        );
        
        if (productPermissions) {
          const canEdit = productPermissions.moduleActivities.find(
            (activity: any) => activity.activityFunction === "edit"
          )?.isSelected || false;
          
          const canDelete = productPermissions.moduleActivities.find(
            (activity: any) => activity.activityFunction === "delete"
          )?.isSelected || false;
          
          return { canEdit, canDelete };
        }
      }
      return { canEdit: false, canDelete: false };
    } catch (error) {
      console.error("Error parsing user permissions:", error);
      return { canEdit: false, canDelete: false };
    }
  }, []);

  // Dynamic actions based on permissions
  const actions = useMemo(() => {
    const baseActions = ["Change Status", "Preview", "Clone"];
    const permittedActions = [];
    
    if (getUserPermissions.canEdit) {
      permittedActions.push("Edit");
    }
    
    if (getUserPermissions.canDelete) {
      permittedActions.push("Delete");
    }
    
    // Combine: Edit first, then Delete, then other actions
    return [
      ...(getUserPermissions.canEdit ? ["Edit"] : []),
      ...(getUserPermissions.canDelete ? ["Delete"] : []),
      ...baseActions
    ];
  }, [getUserPermissions]);

  // Callback function to receive data from the child component
  const handleSelectedRegion = (data: any) => {
    setSelectedRegion(data);
    const payload = data.map((regionToClone: any) => {
      return {
        productName: product.productName,
        attributes: [],
        productImages: product.productImages.map((image: any) => image),
        description: product.description,
        subcategory: product.subcategory._id,
        regions: [regionToClone.id || regionToClone._id],
        category: product.category._id,
        brand: product.brand,
        model: product.model,
        modelNumber: product.modelNumber,
        sku: product.sku,
      };
    });
    setNewPayloads(payload);
  };

  const handleAfterDelete = useCallback(
    (flag: boolean, response: any) => {
      if (flag) {
        toast.success("record deleted");
        dispatch(setRerender(!rerender1));
        // do whatever you want with response
      } else {
        toast.error("error");
      }
    },
    [rerender1, dispatch]
  );
  const { canDo, currentActivity } = usePermissions();

  const handleAfterStatus = useCallback(
    (status: boolean, res: any) => {
      if (status) {
        toast.success("status updated successfully");
        dispatch(setRerender(!rerender1));
      } else {
        //TODO: make error when go live
        toast.error("something went wrong");
      }
    },
    [rerender1, dispatch]
  );

  const handleAfterClone = useCallback(
    (data: any) => {
      // if (status) {
      //   toast.success("Clone created successfully");
      dispatch(setRerender(!rerender1));
      setShowCloneStatusModel(true);
      setStatusData(data);
      // } else {
      //   //TODO: make error when go live
      //   toast.error(res?.data?.message);
      // }
    },
    [rerender1, dispatch]
  );

  const { onDelete, deleteRecord, showPrompt, onCancel, loading } = useDelete(
    deleteProduct,
    true,
    handleAfterDelete
  );

  const {
    onStatus,
    showStatusPrompt,
    statusloading,
    statusToUpdate,
    onstatusCancel,
    ChangeStatus,
  } = useStatus(updateStatus, true, handleAfterStatus);

  const {
    onClone,
    showClonePrompt,
    setCloneShowPrompt,
    cloneLoading,
    recordToClone,
    onCancelClone,
    cloneRecord,
    newRegion,
  } = useClone(
    addProduct,
    true,
    handleAfterClone,
    regions,
    selectedRegion,
    newPayloads
  );

  const handlePreviewPrompt = useCallback(() => {
    setPreviewPrompt(!showPreviewPrompt);
  }, [showPreviewPrompt]);

  const handleCancel = useCallback(() => {
    setShowPermissionPrompt(false);
  }, []);

  const onCloseCloneStatus = useCallback(() => {
    setShowCloneStatusModel(false);
  }, []);

  const onBackHandler = useCallback(() => {
    setShowCloneStatusModel(false);
    setCloneShowPrompt(true);
  }, []);


   const handleMasterAdd = useCallback((product: any) => {
    // console.log("Product data:", product);
      setAddMasterModel(!addMasterModel);
    
     
     
    }, [addMasterModel]);

  const handleSelect = useCallback(
    (selectedAction: string) => {
      switch (selectedAction) {
        case "Edit":
          if (getUserPermissions.canEdit) {
            doEdit(product._id, false);
          } 
          // else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        case "Delete":
          if (getUserPermissions.canDelete) {
            onDelete(product._id);
          } 
          // else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        case "Clone":
          onClone(product);
          break;
        case "Change Status":
          onStatus(product);
          break;
        case "Preview":
          handlePreviewPrompt();
          break;
        default:
          break;
      }
    },
    [getUserPermissions, doEdit, product, onDelete, onClone, handlePreviewPrompt, onStatus]
  );

  return (
    <>
      {showPermissionPrompt && (
        <PermissionPrompt
          title={"Access Denied"}
          image="/media/auth/permission-error-light.svg"
          message={currentActivity ? currentActivity : "You don't have permission to perform this action"}
          onCancel={handleCancel}
          moduleName={moduleName}
        />
      )}
      {showPrompt && (
        <ConfirmationPrompt
          title={"Delete Record"}
          message={"Are you sure to delete this record?"}
          onConfirm={deleteRecord}
          onCancel={onCancel}
          isloading={loading}
        />
      )}
      {showPreviewPrompt && (
        <CarouselDemo
          Images={product?.productImages}
          title={product?.productName}
          categoryName={product?.category?.categoryName}
          subCategoryName={product?.subcategory?.subcategoryName}
          regionName={product?.regions[0]?.regionName}
          description={product?.description}
          sku={product?.sku}
          price={product?.price}
          onCancel={() => handlePreviewPrompt()}
        />
      )}

      {showStatusPrompt && (
        <ConfirmationPrompt
          title="Change Status"
          message="Are you sure you want to change the status ?"
          onCancel={onstatusCancel}
          onConfirm={ChangeStatus}
          isloading={statusloading}
        />
      )}

      {showClonePrompt && (
        <ClonePrompt
          title="Generate Clone"
          onCancel={onCancelClone}
          onConfirm={cloneRecord}
          isloading={cloneLoading}
          filterRegion={newRegion}
          sendSelectedRegionToParent={handleSelectedRegion}
        />
      )}

      {showCloneStatusModel && (
        <CloneRegionModel
          title={"Product Clone Status"}
          onCancel={onCloseCloneStatus}
          statusData={statusData}
          onBack={onBackHandler}
        />
      )}
      <ActionCells actions={actions} onSelect={handleSelect} />
    </>
  );
};
export default ProductTableAction;
